export default "__VITE_ASSET__f33JdTu9__"